import { forwardRef } from 'react';
import ActionButtonInternal from './action-button-internal';
var ActionButton = forwardRef(ActionButtonInternal);
export default ActionButton;
